import React from 'react'
import { useSelector } from 'react-redux'

const Welcome = () => {
    const { user } = useSelector((state) => state.auth)
    return (
        <div>
            <section className="hero is-info welcome is-small">
                <div className="hero-body">
                    <div className="container">
                        <h1 className="title">
                            Hello, {user && user.name}.
                        </h1>
                        <h2 className="subtitle">
                            I hope you are having a great day!
                        </h2>
                    </div>
                </div>
            </section>
            <section className="info-tiles has-text-">
                <div className="tile is-ancestor">
                    <div className="tile is-parent">
                        <article className="tile is-child box">
                            <p className="title is-size-3">Welcome to Ayres IoT Dashboard </p>
                            <p className="subtitle is-size-4">An app that make you posible to monitor temperature & humidity anywhere also everywhere</p>
                            <p className='subtitle is-size-5 has-text-justified'>Our IoT dashboard website is a platform that provides a user-friendly interface to monitor and manage IoT devices and their associated data. It enables users to visualize real-time data from IoT devices in the form of graphs and tables. This data can be analyzed to make informed decisions, detect patterns, and gain insights into the performance of the IoT devices.

                                Our IoT dashboard website also offers features such as data logging, and data export.  The data logging feature allows users to store and retrieve historical data for further analysis, while the data export feature enables them to export data in XLSX format.
                                Overall, our IoT dashboard website provides a powerful tool for monitoring IoT devices, helping businesses and individuals to make informed decisions based on real-time data.</p>
                        </article>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Welcome